import {ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {GpxProcessService} from "../../services/gpxProcess/gpx-process.service";
import {parserMainClass} from "../../classes/parsers/mainParser";
import {parserFactory} from "../../classes/parsers/parseFactory";

@Component({
  selector: 'app-gpx-import',
  templateUrl: './gpx-import.component.html',
  styleUrls: ['./gpx-import.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class GpxImportComponent {

  @ViewChild('fileInput', {static: false}) fileInput;

  public isGPXAvailable = window['POLYLINE_IMPORT_ALLOWED'];
  private modalElmString:string;
  private parser:parserMainClass;
  public importText = Yiit.t('Import GPX route');

  constructor(private gpx:GpxProcessService, private parserFactory:parserFactory) {
    this.modalElmString = this.gpx.modalElmString;
    this.initListeners();
  }

  private initListeners(){
    this.gpx.modalEventFires$.subscribe((event)=>{
      if (event === 'closed'){
        this.fileInput.nativeElement.value = null;
      }
    })
  }


  uploadGpxFile(event){
    let file:File = event.target.files[0];

    this.parser = this.parserFactory.createParserByType(file);

    this.parser.getData().subscribe((trackList)=>{
      this.gpx.updateConfig = this.parser.getConfigFromTrackList(trackList);
      this.gpx.openModal();
    },
      (err)=>{console.error(err); throw new Error(err)});
  }

}
